import { trackTMSPage } from '../tag-commander/datalayer';
import { datalayerStorageClient } from '../tag-commander/datalayerStorage';
import { getConvId } from '../tag-commander/utils';

const { getPreviousDatalayer } = datalayerStorageClient();

export const trackTMSConfirmation = async (
  transactionId: string,
  revenue: number | string
) => {
  const product = getProduct();
  await trackTMSPage(
    {
      env_template: getEnvTemplate(product),
      page_name: 'confirmation',
      g_conv_id: getConvId(),
      product,
      transaction_id: getTransactionId() || transactionId,
      transaction_r_marketing:
        getTransactionRevenueMarketing() || revenue.toString(),
    },
    { skipFetch: true }
  );
};

const getProduct = (): string | undefined => {
  return window?.tc_vars?.product || getPreviousDatalayer()?.product;
};

const getTransactionId = (): string | undefined => {
  return (
    window?.tc_vars?.transaction_id || getPreviousDatalayer()?.transaction_id
  );
};

const getTransactionRevenueMarketing = (): string | undefined => {
  return (
    window?.tc_vars?.transaction_r_marketing ||
    getPreviousDatalayer()?.transaction_r_marketing
  );
};

const getEnvTemplate = (product: string) => {
  const dictionary = {
    DYNPACK: 'confirmation',
    PRIZE_FREEZE_FLIGHT: 'confirmation',
    FLIGHT: 'confirmation',
    TRAIN: 'confirmation',
    XFARING: 'confirmation',
    HOTEL: 'hotel-bf-confirmation',
    SUBSCRIPTION: 'confirmation',
    UPP: 'confirmation',
    'SEAT-PB': 'seat-PB',
    'BAG-PB': 'bag-PB',
    'INSURANCE-PB': 'check-in-PB',
  };
  return dictionary[product] || 'confirmation';
};
